import { useMemo } from 'react';

import { useGetCountriesList } from '@common/slices/drawer.slice';
import { lookupListAsRecordObject } from '@utils/graph-utils';

import { useGetDestinationsLookup } from '../amendment.slice';

export function useTravelDetailsLovs() {
  const { data: lovsData } = useGetDestinationsLookup();
  const { data: countriesData } = useGetCountriesList();

  const destinations = lovsData?.planConfig?.getDestinationsLookup ?? [];

  const departure = useMemo(
    () => lookupListAsRecordObject(countriesData?.core?.getCountries),
    [countriesData]
  );

  const destination = useMemo<Record<string, string>>(
    () =>
      (destinations ?? []).reduce(
        (acc, it) => {
          if (!it?.id) return acc;
          acc[it.id] = it.title || it.code || '';

          return acc;
        },
        {} as Record<string, string>
      ),
    [destinations]
  );

  return { departure, destination };
}
